module.exports = __webpack_public_path__ + "img/xhd_log.ea3be919.png";